import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import ChatMsg from "./ChatMsg";
import SecureMail from "./SecureMail";
import Inbox from "./InboxMessages";
import SentMessages from "./sentMessages";
import SimpleMail from "./SimpleMail";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  CircularProgress,
  DialogContent,
  ThemeProvider,
  createTheme,
  useTheme,
} from "@mui/material"; //FB 7681
import { GetSentMessages, GetAllPhysicians, GetInboxMessages } from "../../../../api";  //FB 7579
import { Message, Physician } from "../../../../store";

// Update log
// FB  6192   02/06/2023  DK  Messages screen for mobile UI
// FB  7579   10/13/2023  DK  no messages when you login to portal on phone
// FB  7620   11/17/2023  SK  PP Messaging - UI issue
// FB  7681   03/04/2024  KI  Orady - need gear icon on mobile when the doc or any pages are loading

//FB 7620 - Begin
interface Option {
  value: string;
  label: string;
}
//FB 7620 - End

const theme = createTheme({
  palette: {
    primary: {
      main: "#083A4D",
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});

export default function MessageMobileUI() {
  const [inboxMessages, setInboxMessages] = useState<Message[]>();  //FB 7579
  const [sentMessages, setSentMessages] = useState<Message[]>();
  const [physicians, setPhysicians] = useState<Physician[]>();
  const [age, setAge] = useState("Inbox");
  const [inbox, setInbox] = useState(true);
  const [sendMessage, setSendMessage] = useState(false);
  const [secureMail, setSecureMail] = useState(false);
  const [sent, setSent] = useState(false);
  const [simpleMail, setSimpleMail] = useState(false);
  //const [showSpinner, setShowSpinner] = useState(false); FB 7681

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);

    if (event.target.value == "Inbox") {
      setInbox(true);
      setSendMessage(false);
      setSecureMail(false);
      setSimpleMail(false);
      setSent(false);
    } else if (event.target.value == "Message") {
      setSendMessage(true);
      setSecureMail(false);
      setInbox(false);
      setSimpleMail(false);
      setSent(false);
    } else if (event.target.value == "SecureMail") {
      setSecureMail(true);
      setInbox(false);
      setSendMessage(false);
      setSimpleMail(false);
      setSent(false);
    } else if (event.target.value == "SimlpeMail") {
      setSecureMail(false);
      setInbox(false);
      setSendMessage(false);
      setSimpleMail(true);
      setSent(false);
    } else if (event.target.value == "Sent") {
      setSent(true);
      setSecureMail(false);
      setInbox(false);
      setSendMessage(false);
      setSimpleMail(false);
    }
  };
  const navigate = useNavigate();

  async function GetPhysicians() {
    const data = await GetAllPhysicians();
    setPhysicians(data);
  }

  //FB 7681 - Begin
  const [showSpinner, setShowSpinner] = useState(false);
  const theme = useTheme();
  //FB 7681 - End

  async function GetSent() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        const data = await GetSentMessages(user.Patient_n);
        setSentMessages(data);
      }
    }
  }

  //FB 7620 - Begin
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  // Options for the dropdown
  const options: Option[] = [
    { value: 'Message', label: 'Send a Message' },
    { value: 'SecureMail', label: 'Secure Mail' },
    { value: 'SimlpeMail', label: 'Simple Mail' },
    { value: 'Sent', label: 'Sent' },
  ];
  //FB 7620 - End
  //FB 7579
  async function GetInbox() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        const data = await GetInboxMessages(user.Patient_n);
        setInboxMessages(data);
      }
    }
  }

  React.useEffect(() => {
    setShowSpinner(true);  //FB 7681
    GetSent();
    GetPhysicians();
    GetInbox(); //FB 7579
    //FB 7681 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 5000);
    //FB 7681 - End
  }, []);

  return (
    <Box sx={{ minWidth: 120, margin: "20px" }}>
      {/* FB 7620 - Replaced FormControl with select - Begin */}
      <select
        style={{ width: "100%", height: "35px" }}
        value={selectedValue || undefined}
        onChange={(e: any) => handleChange(e)}
      >
        <option defaultValue="Inbox">
          Inbox
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {/* FB 7620 - End */}
      <Grid container>
        <Grid item xs={12}>
          {sendMessage && <ChatMsg />}
          {secureMail && <SecureMail />}
          {inbox && <Inbox messages={inboxMessages} physicians={physicians} />} {/*FB 7579*/}
          {sent && (
            <SentMessages messages={sentMessages} physicians={physicians} />
          )}
          {simpleMail && <SimpleMail />}
        </Grid>
      </Grid>
      {/* FB 7620 - Removed Unused Part Of Code */}
      {/* FB 7681 - Begin */}
      <ThemeProvider theme={theme}>
          <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
            <DialogContent
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress style={{ color: "#083A4D" }} />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
        {/* FB 7681 - End */}
    </Box>
  );
}
